import React from "react";

import {IoIosArrowUp} from "react-icons/io";
import Button from "../Button";

export const Collapse = ({children, handleClick = {}}) => {
    return (
        <div className="collapse" id="filter-collapse">
            <div className="card card-body border-0 py-0 my-0">
                <div className="px-4 py-2 text-start">

                    { children }

                    <div className="text-center">
                        <button style={{border: '1px solid black', padding: '5px 15px', background: 'transparent'}} width="50px" data-bs-toggle="collapse" onClick={handleClick}
                                 data-bs-target="#filter-collapse" aria-expanded="false" aria-controls="filter-collapse">
                            <IoIosArrowUp />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
